<div class="auth-body h-screen relative">
  <!-- Footer -->
  <div class="absolute bottom-0 w-full flex justify-center flex-row">
    <div class="p-4 w-full bg-white">
      <p class="text-center text-[#797C83] footer-branding">
        A Product by
        <b>
          <a
            target="_blank"
            href="https://purple.lk/"
            class="text-[#797C83] hover:text-[#640D5C]"
          >
            Purple Software
          </a>
        </b>
      </p>
    </div>
  </div>

  <div class="grid lg:grid-cols-2 h-full">

    <!-- LEFT IMAGE -->
    <div class="bg-slate-200 hidden lg:flex items-center justify-end">
      <div class="bg-white h-4/6 w-8/12 p-1 drop-shadow-lg">
        <img
          class="h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1655367382249-7598af406124?auto=format&fit=crop&w=1770&q=80"
        />
      </div>
    </div>

    <!-- RIGHT CONTENT -->
    <div class="lg:bg-primary flex items-center justify-start">
      <div
        class="lg:bg-white w-full lg:h-4/6 lg:w-8/12 drop-shadow-lg flex items-center justify-center"
      >
        <div class="w-8/12 lg:w-7/12 text-center">
          <div *ngIf="verifying">
            <h5 class="flex items-center justify-center gap-2">
              Verifying your email
              <span nz-icon nzType="loading"></span>
            </h5>
          </div>
          <div *ngIf="!verifying" class="text-center">
            <div
              class="flex justify-center items-center w-16 h-16 mx-auto rounded-full mb-4"
              [ngClass]="{
                'bg-green-100': success,
                'bg-red-100': !success
              }"
            >
              <span
                nz-icon
                [nzType]="success ? 'check' : 'close'"
                [ngClass]="{
                  'text-green-600 text-2xl': success,
                  'text-red-600 text-2xl': !success
                }"
              ></span>
            </div>
            <h2 class="text-xl font-semibold mb-2">
              {{ success ? 'Email Verified!' : 'Verification Failed' }}
            </h2>
            <p class="text-gray-500 mb-6">
              {{ message }}
            </p>
            <button nz-button nzType="default" (click)="goToLogin()">
              Go Back to Login
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
